<template>
    <div v-if="teacher">
        <TeachersViewInfo />
        <TeachersViewGeneral />
    </div>
</template>

<script>
import { onUnmounted, provide, ref } from '@vue/composition-api';
import TeachersViewGeneral from './TeachersViewGeneral.vue';
import TeachersViewInfo from './TeachersViewInfo.vue';
import teacherModule from '../teacherModule';
import router from '@/router';
import store from '@/store';

export default {
    components: { TeachersViewGeneral, TeachersViewInfo },
    setup(){
        const TEACHER_MODULE = 'teachers'
        const teacher = ref(null)
        const groups = ref(null)

        provide('teacher', teacher)
        provide('groups', groups)

        if(!store.hasModule(TEACHER_MODULE)) store.registerModule(TEACHER_MODULE, teacherModule)

        onUnmounted(() => {
            if(store.hasModule(TEACHER_MODULE)) store.unregisterModule(TEACHER_MODULE)
        })

        store.dispatch('teachers/fetchTeacher', { id: router.currentRoute.params.id } ).then(response => { 
            teacher.value = response.data.teacher
            groups.value = response.data.groups
        })

        return {
            teacher
        }
    }
}
</script>